/**
 * Event definitions
 */
export const EVENTS = {
  INTRO_SCREEN: 'intro-screen',
  IS_NOT_DEFINED: 'condition not defined',
  APPOINTMENT_IS_FOR: 'appointment-is-for',
  NEW_PATIENT: 'new-patient',
  LAST_SEEN_DURATION: 'last-seen-duration',
  INSURANCE: 'insurance-info',
  INSURANCE_IS_HMO: 'insurance-is-hmo',
  INSURANCE_IS_MEDICAID: 'insurance-is-medicaid',
  MORE_INFO: 'need-more-info',
  DATE_PREF: 'date-preference',
  PURPOSE: 'select-purpose',
  APPT_TYPE: 'medical-or-cosmetic',
  SKIN_CANCER_HISTORY: 'skin-cancer-history',
  LOCATION: 'select-location',
  APPOINTMENT: 'select-appointment',
  PROVIDER: 'select-provider',
  PERSONAL_INFO: 'personal-information',
  AREAS_OF_CONCERN: 'areas-of-concern',
  CONFIRMATION: 'confirmation',
  MISSING: 'missing',
  THIRTEEN_OR_OLDER: 'thirteen-or-older',
  EXPERIENCING_HAIR_LOSS: 'experiencing-hair-loss',
  FIRST_HAIR_LOSS_EVALUATION: 'first-hair-loss-evaluation',
  PSORIASIS_BIOLOGICS_INTEREST: 'psoriasis-biologics-interest',
  ACTIVE_ACNE_PRESENT: 'active-acne-present',
  RECEIVED_INJECTABLES_BEFORE: 'received-injectables-before',
  STRETCH_MARK_COLOR: 'stretch-mark-color',
  PRIOR_LASER_APPROVAL: 'prior-laser-approval',
  SAME_DAY_TREATMENT_NOTICE: 'prior-laser-approval-notice',
  HEAR_ABOUT_DERICK: 'hear-about-derick',
  WHICH_BUILDING_SIGN: 'which-building-sign',
  WHICH_EMPLOYEE: 'which-employee',
  WHICH_INSURANCE_WEBSITE: 'which-insurance-website',
  WHICH_PATIENT: 'which-patient',
  WHICH_PHYSICIAN: 'which-physician',
  WHICH_OTHER: 'which-other',
  IS_65_OR_OLDER: 'is-65-or-older',
  ZIP_CODE: 'zip-code',
  SELECT_YOUR_STATE: 'select-your-state',
  IS_18_OR_OLDER: 'is-18-or-older',
  UNSPECIFIED_PURPOSE_INPUT: 'unspecified-purpose-input',
  MEDICAL_SUGGESTION: 'medical-suggestion',
  SWITCH_TO_MEDICAL: 'switch-to-medical',
  SCHEDULED: 'scheduled',
  SCHEDULED_FL: 'scheduled-fl',
  SCHEDULE_REQUESTED: 'schedule-requested',
  NEW_PATIENT_SCHEDULED: 'new-patient-scheduled',
  NEW_PATIENT_SCHEDULED_FL: 'new-patient-scheduled-fl',
  NEW_PATIENT_SCHEDULE_REQUESTED: 'new-patient-schedule-requested',
  SEARCH_RESULTS_RETURNED: 'search-results-returned',
};

/**
 * Event hashes for logging
 */
export const EVENT_CODES = {
  [EVENTS.INTRO_SCREEN]: 'a1XZ9',
  [EVENTS.AREAS_OF_CONCERN]: 'b2YW8',
  [EVENTS.APPOINTMENT]: 'c3XV7',
  [EVENTS.APPOINTMENT_IS_FOR]: 'd4WU6',
  [EVENTS.APPT_TYPE]: 'e5VT5',
  [EVENTS.CONFIRMATION]: 'f6US4',
  [EVENTS.DATE_PREF]: 'g7TR3',
  [EVENTS.INSURANCE]: 'h8SQ2',
  [EVENTS.LAST_SEEN_DURATION]: 'j0QO0',
  [EVENTS.LOCATION]: 'k1PN9',
  [EVENTS.MORE_INFO]: 'l2OM8',
  [EVENTS.PERSONAL_INFO]: 'm3NL7',
  [EVENTS.PURPOSE]: 'n4MK6',
  [EVENTS.PROVIDER]: 'o5LJ5',
  [EVENTS.SKIN_CANCER_HISTORY]: 'p6KI4',
  [EVENTS.THIRTEEN_OR_OLDER]: 'q7JH3',
  [EVENTS.FIRST_HAIR_LOSS_EVALUATION]: 'r8IG2',
  [EVENTS.PSORIASIS_BIOLOGICS_INTEREST]: 's9HF1',
  [EVENTS.ACTIVE_ACNE_PRESENT]: 't0GE0',
  [EVENTS.RECEIVED_INJECTABLES_BEFORE]: 'u1FD9',
  [EVENTS.STRETCH_MARK_COLOR]: 'v2EC8',
  [EVENTS.PRIOR_LASER_APPROVAL]: 'w3DB7',
  [EVENTS.SAME_DAY_TREATMENT_NOTICE]: 'x4CA6',
  [EVENTS.NEW_PATIENT]: 'y5BZ5',
  [EVENTS.HEAR_ABOUT_DERICK]: 'z6AY4',
  [EVENTS.WHICH_BUILDING_SIGN]: 'A7XZ3',
  [EVENTS.WHICH_EMPLOYEE]: 'B8YW2',
  [EVENTS.WHICH_INSURANCE_WEBSITE]: 'C9XV1',
  [EVENTS.WHICH_PATIENT]: 'D0WU0',
  [EVENTS.WHICH_PHYSICIAN]: 'E1VT9',
  [EVENTS.WHICH_OTHER]: 'F2US8',
  [EVENTS.IS_65_OR_OLDER]: 'G3TR7',
  [EVENTS.ZIP_CODE]: 'H4SQ6',
  [EVENTS.SELECT_YOUR_STATE]: 'I5RP5',
  [EVENTS.UNSPECIFIED_PURPOSE_INPUT]: 'J6QO4',
  [EVENTS.MEDICAL_SUGGESTION]: 'K7PN3',
  [EVENTS.SWITCH_TO_MEDICAL]: 'L8OM2',
  [EVENTS.SCHEDULED]: 'Q2GJ5',
  [EVENTS.SCHEDULED_FL]: 'R3FI6',
  [EVENTS.SCHEDULE_REQUESTED]: 'S4EH7',
  [EVENTS.NEW_PATIENT_SCHEDULED]: 'M9KL3',
  [EVENTS.NEW_PATIENT_SCHEDULED_FL]: 'N0JM2',
  [EVENTS.NEW_PATIENT_SCHEDULE_REQUESTED]: 'P1HK4',
  [EVENTS.SEARCH_RESULTS_RETURNED]: 'T5DG8',
};

/**
 * Error Message Strings
 */
export const ERROR_MESSAGES = {
  NO_PROVIDERS: 'No providers were returned from the API.',
  NO_PURPOSES: 'No purposes were returned from the API.',
  NO_LOCATIONS: 'No locations were returned from the API.',
  NO_APPOINTMENTS: 'No appointments were returned.',
};

/**
 * Insurance definitions
 */
export const INSURANCES = {
  PPO: 'PPO',
  HMO: 'HMO',
  MEDICARE: 'Medicare',
  MEDICAID: 'Medicaid',
  NONE: 'None/Self Pay',
  UNK: 'I do not know',
};

/**
 * Medicaid insurances
 */
export const INSURANCES_MEDICAID = {
  MERIDIAN: 'Meridian',
  BCBS_COMMUNITY_MMAI: 'BCBS Community MMAI',
  OTHER: 'Other',
};

/**
 * Appointment Types
 */
export const APPT_TYPES = {
  MEDICAL: 'Medical',
  SURGICAL: 'Surgical',
  COSMETIC: 'Cosmetic',
};

/**
 * Default rule properties
 */
export const DEFAULT_RULE_PROPERTIES = {
  default: false,
  evaluate: '',
  nextEvent: '',
  ignoreIfAnswered: false,
};

/**
 * Default requirement properties
 */
export const DEFAULT_REQUIREMENT_PROPERTIES = {
  requiredEvent: '',
  value: '',
};

/**
 * Default event properties
 */
export const DEFAULT_EVENT_PROPERTIES = {
  id: false,
  component: false,
  showConfirmation: true,
  result: null,
  viewed: false,
  review: false,
  requirements: [],
  rules: [],
  validationCallback: {
    message: '',
    fn: false,
  },
};

/**
 * Default appointment
 */
export const DEFAULT_APPOINTMENT_PROPERTIES = {
  ApptStart: '',
  LocationId: 0,
  OfferId: '',
  ProviderId: 0,
  MatchedStrength: 100,
};

/**
 * Query types
 */
export const QUERY_TYPE = {
  LOCATIONS: 'locations',
  PURPOSES: 'purposes',
  PROVIDERS: 'providers',
  SEARCH: 'search',
  SEARCH_V2: 'search_v2',
  SEARCH_V3: 'search_v3',
  BOOK: 'book',
  HOLD: 'hold',
  REQUEST: 'request',
  HEARTBEAT: 'heartbeat',
};

/**
 * Reset event types
 *
 * Each entry is a list of events to mark for review (`review: true`). The rules
 * engine then walks the FIXED event chain and stops at each event flagged for
 * review, skipping any already-viewed event that wasn't reset. So a reset group
 * is "which screens to re-show" — they always reappear in chain order, never in
 * the order listed here.
 *
 * Relevant slice of the chain (see EventDefinitions.js):
 *   PROVIDER -> DATE_PREF -> ZIP_CODE -> LOCATION -> APPOINTMENT
 *
 * The three appointment-flow reset groups below are easy to confuse. They are
 * triggered by different result strings on the APPOINTMENT event (handled in
 * EventViewer.js) and differ only in which screens they re-show before landing
 * the user back on APPOINTMENT to re-search:
 *
 *   APPOINTMENT_REFINE_SEARCH    (result: 'refine search', V2/V3 "Refine Search")
 *       re-shows: provider -> date-pref -> location -> search
 *       The original full refine: re-pick provider AND date AND location.
 *
 *   APPOINTMENT_REFINE_SEARCH_V4 (result: 'Refine Search V4', V4 "Refine Search")
 *       re-shows: date-pref -> location -> search
 *       Same as above but WITHOUT provider. V4 deliberately drops provider from
 *       the refine pass so refining is purely date/location.
 *
 *   APPOINTMENT_CHOOSE_PROVIDER  (result: 'Choose Provider', V4 "...by name" link)
 *       re-shows: provider -> search
 *       Provider ONLY. Everything after provider (date/zip/location) is already
 *       viewed and not reset, so the engine falls straight through to APPOINTMENT
 *       and re-searches with the newly chosen provider, preserving date/location.
 *
 * Note: ZIP_CODE is never in these groups — once viewed it stays viewed, so the
 * engine skips it and the patient's zip is never re-prompted during a refine.
 */
export const RESET_EVENTS = {
  // V2/V3 "Refine Search": re-pick provider, date, and location.
  APPOINTMENT_REFINE_SEARCH: [
    EVENTS.PROVIDER,
    EVENTS.LOCATION,
    EVENTS.DATE_PREF,
  ],
  // V4 "Refine Search": re-pick date and location only (no provider).
  APPOINTMENT_REFINE_SEARCH_V4: [
    EVENTS.DATE_PREF,
    EVENTS.LOCATION,
  ],
  // V4 "Or, choose a provider by name": re-pick provider only, then re-search
  // with date/location preserved.
  APPOINTMENT_CHOOSE_PROVIDER: [EVENTS.PROVIDER],
  MORE_INFO_UPDATE: [EVENTS.DATE_PREF, EVENTS.LOCATION, EVENTS.PERSONAL_INFO],
  STRETCH_MARK_NO: [EVENTS.PURPOSE, EVENTS.STRETCH_MARK_COLOR],
  RECEIVED_INJECTABLES: [EVENTS.PURPOSE, EVENTS.RECEIVED_INJECTABLES_BEFORE],
  ZIP_CODE_RESET: [EVENTS.ZIP_CODE],
  STATE_RESET: [EVENTS.SELECT_YOUR_STATE],
};

/**
 * Purpose type definitions
 */
export const PURPOSE_TYPE = {
  NEW_MEDICAL: 'NewMedical',
  ESTABLISHED_MEDICAL: 'EstablishedMedical',
  COSMETIC: 'Cosmetic',
};

export const APPT_TYPE_IDS = {
  CC: 16,
  CPA: 25,
  CPP: 18,
  EM: 19,
  NM: 21,
};

export const APPT_PURPOSES = {
  UNSPECIFIED_MEDICAL: 67,
  UNSPECIFIED_COSMETIC: 111,
  IPL_OFFSITE: 287,
  IPL: 86,
  ABSCESS: 120,
  ACNE_SCARS: 9001,
  ACNE: 62,
  AGING_SKIN: 106,
  AK: 143,
  BIOLOGICS_FIRST_EVALUATION: 297,
  BIOLOGICS_FOLLOW_UP: 298,
  BOTOX: 64,
  BROWN_SPOTS: 9002,
  COOLSCULPTING: 102,
  ECZEMA: 220,
  FACIAL_VEIN_REDUCTION: 9003,
  FILLER_UNDER_EYE: 293,
  FILLER: 88,
  FOLLICULITIS: 230,
  DANDRUFF: 121,
  FRAXEL: 306,
  HAIR_LOSS_FIRST_EVALUATION: 295,
  HAIR_LOSS_FOLLOW_UP: 296,
  HAIR_LOSS: 91,
  HYPERHIDROSIS: 126,
  ISOTRETINOIN_FEMALE: 274,
  ISOTRETINOIN_MALE: 273,
  ISOTRETINOIN: 131,
  LASER_HAIR_REMOVAL_OFFSITE: 288,
  LASER_HAIR_REMOVAL: 103,
  LESION: 99,
  MICRONEEDLING_OFFSITE: 328,
  MICRONEEDLING: 327,
  MLE: 238,
  MOLLUSCUM_OVER_13: 276,
  MOLLUSCUM_UNDER_13: 275,
  MOLLUSCUM: 145,
  NAIL: 125,
  NOT_FOUND: -1,
  PICO_OFFSITE: 290,
  PICO: 223,
  PSORIASIS: 141,
  RASH: 87,
  REDNESS: 9004,
  RESURFACING: 149,
  ROSACEA: 123,
  SCAR: 110,
  SCE_64_OR_LESS: 286,
  SCE_65_OR_GREATER: 285,
  SCE: 239,
  SEBORRHEIC_DERMATITIS: 231,
  SK: 144,
  SKIN_TAG: 155,
  STRETCH_MARKS: 109,
  TATTOO_REMOVAL_OFFSITE: 291,
  TATTOO_REMOVAL: 94,
  VBEAM_OFFSITE: 292,
  VBEAM: 85,
  WARTS_OVER_13: 247,
  WARTS_UNDER_13: 246,
  WARTS: 124,
};

/**
 * For cosmetic appointment searching, the primary purpose id is listed
 * here as the index, where the "offsite" id is listed as the new purpose
 * ID. This hooks into the cosmetic searching, so if there are no results
 * for the primary cosmetic purpose, it will check for offsite options also.
 */
export const OFFSITE_COSMETIC_SEARCH = {
  [APPT_PURPOSES.IPL]: APPT_PURPOSES.IPL_OFFSITE,
  [APPT_PURPOSES.LASER_HAIR_REMOVAL]: APPT_PURPOSES.LASER_HAIR_REMOVAL_OFFSITE,
  [APPT_PURPOSES.PICO]: APPT_PURPOSES.PICO_OFFSITE,
  [APPT_PURPOSES.TATTOO_REMOVAL]: APPT_PURPOSES.TATTOO_REMOVAL_OFFSITE,
  [APPT_PURPOSES.MICRONEEDLING]: APPT_PURPOSES.MICRONEEDLING_OFFSITE,
  [APPT_PURPOSES.VBEAM]: APPT_PURPOSES.VBEAM_OFFSITE,
  [APPT_PURPOSES.REDNESS]: APPT_PURPOSES.VBEAM_OFFSITE,
  [APPT_PURPOSES.STRETCH_MARKS]: APPT_PURPOSES.VBEAM_OFFSITE,
  [APPT_PURPOSES.FACIAL_VEIN_REDUCTION]: APPT_PURPOSES.VBEAM_OFFSITE,
};

/**
 * List of days of the week, used with the date functions to convert
 * the day of the week (numeric value) to the string equivilent.
 */
export const DAY_OF_WEEK = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

/**
 * Time of day options for the date preferences
 */
export const TIME_OF_DAY_OPTIONS = [
  'Any',
  'Morning (7:00AM - 11:00AM)',
  'Afternoon (11:00AM - 4:00PM)',
  'Evening (4:00PM - 7:00PM)',
];

/**
 * All hours listed here for the time selection on the date
 * preferences screen.
 */
export const DEFAULT_ALL_HOUR_SELECTION = [
  7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
];

/**
 * All days of the week, Monday - Saturday represented in
 * numeric format. Used in the date preferences screen.
 */
export const DEFAULT_ALL_DAYS_OF_WEEK_SELECTION = [2, 3, 4, 5, 6, 7];

/**
 * Appointment is for options
 */
export const APPT_FOR = {
  PATIENT: 'Myself',
  OTHER: 'Someone Else',
};

/**
 * Device types
 */
export const DEVICE_TYPE = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
};

/**
 * Device constants for mobile styling/theming/functionality
 */
export const DEVICE_CONSTANTS = {
  MOBILE_HEIGHT: 850,
};

/**
 * Options for the "How did you hear about us" question.
 */
export const HOW_HEAR_ABOUT_US_OPTIONS = [
  'Billboard',
  'Building Sign',
  'Email Marketing ',
  'Employee',
  'Facebook',
  'Google',
  'Insurance Website',
  'Newspaper',
  'Nextdoor.com',
  'Patient',
  'Physician',
  'Radio',
  'Television',
  'Word Of Mouth',
  'Other',
];

/**
 * All the options that require a follow-up question.
 */
export const SPECIAL_HEAR_ABOUT_US_OPTIONS = [
  'Building Sign',
  'Employee',
  'Patient',
  'Physician',
  'Other',
];

/**
 * Building sign locations
 */
export const BUILDING_SIGN_OPTIONS = [
  'FL - Riverview',
  'FL - Westshore',
  'IL - Arlington Heights',
  'IL - Bartlett',
  'IL - Bolingbrook',
  'IL - Burr Ridge',
  'IL - Crystal Lake',
  'IL - Elgin',
  'IL - Geneva',
  'IL - Libertyville',
  'IL - Lindenhurst',
  'IL - McHenry',
  'IL - Naperville',
  'IL - Oak Brook',
  'IL - Oak Park',
  'IL - Orland Park',
  'IL - Park Ridge',
  'IL - Skokie',
];

/**
 * Default date range for the appointment search (in days)
 */
export const DEFAULT_DATE_RANGE_IN_DAYS = 90;

export const DEFAULT_APPOINTMENT_COUNT_SEARCH_LIMIT = 10;

/**
 * List of number keys on the keyboard. Used to limit known
 * number data entry events
 */
export const NUMBER_KEYS = [
  'Digit0',
  'Digit1',
  'Digit2',
  'Digit3',
  'Digit4',
  'Digit5',
  'Digit6',
  'Digit7',
  'Digit8',
  'Digit9',
  'Numpad0',
  'Numpad1',
  'Numpad2',
  'Numpad3',
  'Numpad4',
  'Numpad5',
  'Numpad6',
  'Numpad7',
  'Numpad8',
  'Numpad9]',
];

/**
 * Variable types available for data validation
 */
export const VARIABLE_TYPES = [
  'undefined',
  'string',
  'bigint',
  'boolean',
  'number',
  'object',
  'function',
  'array',
  'zipcode',
];

/**
 * The two separate button ID's for appointment booking and
 * appointment requests.
 */
export const APPOINTMENT_REQUEST_BUTTON_ID = {
  appointment: 'button-appointment',
  request: 'button-appointment-request',
};

/**
 * Options for the "Sex" dropdown on the personal information screen.
 */
export const SEX_OPTIONS = ['Male', 'Female'];

/**
 * Options for the "Translator" dropdown on the personal information screen.
 */
export const TRANSLATOR_OPTIONS = ['No', 'Yes - Requires Translator'];

/**
 * Insurance carrier logos. `logo` is resolved against CONTENT_URI at render time
 * (same pattern as BANNER_IMG); files live in assets/insurance/. `width`/`height`
 * are the intrinsic display dimensions from the design (Self-Schedule 2026), used
 * to render each logo at its true aspect ratio inside the 56px carrier row.
 */
const INSURANCE_LOGOS = {
  bcbs: { name: 'Blue Cross Blue Shield', logo: 'insurance/bcbs.png', width: 140, height: 29 },
  medicare: { name: 'Medicare', logo: 'insurance/medicare.png', width: 127, height: 40 },
  uhc: { name: 'United Healthcare', logo: 'insurance/uhc.png', width: 127, height: 40 },
  aetna: { name: 'Aetna', logo: 'insurance/aetna.png', width: 150, height: 40 },
  cigna: { name: 'Cigna', logo: 'insurance/cigna.png', width: 119, height: 40 },
  floridablue: { name: 'Florida Blue', logo: 'insurance/floridablue.png', width: 190, height: 21 },
};

/**
 * Carriers shown on the v2 Insurance step, by state. Order and membership mirror
 * the Self-Schedule 2026 design frames (Illinois / Florida insurance variants).
 * The selected value persisted to the snapshot is `name`.
 */
export const INSURANCE_CARRIERS_BY_STATE = {
  Illinois: [
    { key: 'bcbs', ...INSURANCE_LOGOS.bcbs },
    { key: 'medicare', ...INSURANCE_LOGOS.medicare },
    { key: 'aetna', ...INSURANCE_LOGOS.aetna },
    { key: 'uhc', ...INSURANCE_LOGOS.uhc },
    { key: 'cigna', ...INSURANCE_LOGOS.cigna },
  ],
  Florida: [
    { key: 'floridablue', ...INSURANCE_LOGOS.floridablue },
    { key: 'uhc', ...INSURANCE_LOGOS.uhc },
    { key: 'cigna', ...INSURANCE_LOGOS.cigna },
    { key: 'medicare', ...INSURANCE_LOGOS.medicare },
    { key: 'aetna', ...INSURANCE_LOGOS.aetna },
  ],
};

/**
 * Options for the "Capable" dropdown on the personal information screen.
 */
export const CAPABLE_OPTIONS = [
  'Yes, I make my own medical decisions',
  "No, I have a legal guardian because I'm under 18 years old",
  'No, I have a legal guardian for other reasons',
];

//Messages to display based on the selected CAPABLE_OPTIONS
export const CAPABLE_OPTION_MESSAGES = {
  [CAPABLE_OPTIONS[1]]:
    'A parent or legal guardian must be present at all appointments, as minors cannot provide legal consent for treatment. If this is not possible, please contact our office prior to the appointment to discuss alternative arrangements.',
  [CAPABLE_OPTIONS[2]]:
    'Ensure all necessary legal documents, including Power of Attorney, are submitted before your appointment for verification.',
};

/**
 * Options for the "Relation" dropdown on the personal information screen, specifying a Guardian's relation the the user.
 */
export const GUARDIAN_OPTIONS = [
  '- None -',
  'Assistant',
  'Assisted Living Facility',
  'Aunt',
  'Best Friend',
  'Boyfriend',
  'Brother',
  'Daughter',
  'Daughter In Law',
  'Ex-Husband',
  'Ex-Wife',
  'Father',
  'Fiance',
  'Friend',
  'Girlfriend',
  'Granddaughter',
  'Grandfather',
  'Grandmother',
  'Grandson',
  'Home Health Service',
  'Husband',
  'Legal Guardian',
  'Mother',
  'Nephew',
  'Niece',
  'Other',
  'Parents',
  'Partner',
  'Power of Attorney',
  'Sister',
  'Son',
  'Spouse',
  'Uncle',
  'Wife',
];

/**
 * React-query url paths.
 */
export const QUERY_URL_PATH = {
  [QUERY_TYPE.PROVIDERS]: '/providers',
  [QUERY_TYPE.LOCATIONS]: '/locations',
  [QUERY_TYPE.PURPOSES]: '/appointments/purposes',
  [QUERY_TYPE.SEARCH]: '/appointments/search',
  [QUERY_TYPE.SEARCH_V2]: '/appointments/search/self',
  [QUERY_TYPE.SEARCH_V3]: '/appointments/search/self/v3',
  [QUERY_TYPE.BOOK]: '/appointments/#id/book',
  [QUERY_TYPE.HOLD]: '/appointments/#id/hold',
  [QUERY_TYPE.REQUEST]: '/appointments/request',
  [QUERY_TYPE.HEARTBEAT]: '/heartbeat',
};

/**
 * Default react-query config variables
 */
export const QUERY_CONFIG_DEFAULT = {
  retry: 3,
  retryDelay: 5000,
  staleTime: 1000,
  refetchInterval: false,
  refetchOnMount: true,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
};

/**
 * React query parameters for limiting refetches and caching
 */
export const QUERY_CONFIG_DISABLE_CACHE = {
  cacheTime: 0,
};

/**
 * Config specific to the appointment query
 */
export const QUERY_CONFIG_APPOINTMENT = {
  ...QUERY_CONFIG_DEFAULT,
  ...QUERY_CONFIG_DISABLE_CACHE,
  refetchInterval: 120000, // 2 minutes
};

/**
 * The states that you are allowed to schedule in
 */
export const SCHEDULABLE_STATES = [
  { long: 'Illinois', short: 'il' },
  { long: 'Florida', short: 'fl' },
];

/**
 * Default personal information
 */
export const DEFAULT_PERSONAL_INFORMATION = {
  firstName: '',
  lastName: '',
  dob: '',
  phone: '',
  email: '',
  address1: '',
  address2: '',
  city: '',
  state: '',
  zip: '',
  sex: '',
  insuranceCompany: '',
  insuranceGroupNumber: '',
  insuranceMemberId: '',
  insurancePoBox: '',
  message: '',
  language: '',
  translator: TRANSLATOR_OPTIONS[0],
  capable: CAPABLE_OPTIONS[0],
  guardians: [],
  // No smsConsentAt default: it is only set when the box is actually ticked.
  smsConsent: false,
};

/**
 * Cosmetic keywords used to determine if an unspecified purpose should remain cosmetic
 * These are case-insensitive and will be matched within user-entered text
 */
export const COSMETIC_KEYWORDS = [
  'botox',
  'dysport',
  'xeomin',
  'jeuveau',
  'filler',
  'juvederm',
  'restylane',
  'belotero',
  'radiesse',
  'sculptra',
  'laser',
  'hair removal',
  'resurfacing',
  'photofacial',
  'ipl',
  'thermage',
  'cool',
  'sculpting',
  'microneedling',
  'chemical peel',
  'peel',
  'aging',
  'wrinkle',
  'line',
  'rejuvenation',
  'tightening',
  'vein',
  'facial',
  'tattoo removal',
  'brown spot',
  'spider vein',
  'redness',
  'rosacea treatment',
  'cosmetic',
  'appearance',
  'look younger',
  'younger looking',
];

/**
 * Medical keywords that indicate the appointment should definitely be medical
 * These take precedence over cosmetic keywords if both are found
 */
export const MEDICAL_KEYWORDS = [
  'hair loss',
  'baldness',
  'thinning hair',
  'alopecia',
  'mole',
  'suspicious',
  'growth',
  'itchy',
  'painful',
  'bleeding',
  'infection',
  'antibiotics',
  'prescription',
  'insurance',
  'covered',
  'diagnosis',
  'disease',
  'condition',
  'problem',
  'treatment',
  'medication',
];

/**
 * Text for the medical suggestion feature
 */
export const MEDICAL_SUGGESTION_TEXT = {
  TITLE: 'Your concern might be better suited for a medical consultation',
  BODY: 'This could give you more comprehensive care options. Your appointment could be processed as medical, which may be covered by insurance.',
  SWITCH_BUTTON: 'Switch to medical consultation',
  DISMISS_ARIA: 'Keep as cosmetic consultation',
};

/**
 * Version of the consent copy the patient was shown.
 *
 * TCPA evidence is "what exactly did they see", so CONSENT_COPY below is
 * APPEND-ONLY: never edit a string in place. To change wording, bump this
 * version and add the new strings, so an old record still resolves to the
 * text that was actually on screen when it was captured.
 *
 * @see docs/REQUIREMENTS.md section 5.2.0
 */
export const CONSENT_FORM_VERSION = '2026.09.2';

/**
 * Consent copy shown on the Contact Information step.
 *
 * Single source of truth for the component, the e2e page object and the
 * REQUIREMENTS document. TOS_LABEL deliberately contains no reference to text
 * messages: it is a terms-of-service agreement, not messaging consent, and
 * bundling the two into one required checkbox is what failed the CTIA audit.
 *
 * @see docs/REQUIREMENTS.md sections 5.1.2 and 5.2.0
 */
export const CONSENT_COPY = {
  // Clickwrap, shown beside the button that actually books. There is no
  // terms-of-service checkbox: the audit rejected a mandatory one, and an
  // optional one adds nothing that pressing the booking button does not already
  // express. The terms stay one click away so acceptance can be informed.
  TOS_ACKNOWLEDGEMENT: 'By booking this appointment you agree to the',
  TOS_LINK_TEXT: 'terms of service',
  // RETIRED COPY -- last rendered by form version 2026.09.1, superseded by
  // SMS_DISCLOSURE_V2. Kept because CONSENT_COPY is append-only: a record
  // stamped 2026.09.1 must still resolve to the text that was on screen.
  SMS_DISCLOSURE:
    'By providing your phone number, you agree to receive transactional appointment-related communications from Derick Dermatology. Providing your number here does not opt you into marketing or promotional texts. Message frequency varies and message and data rates may apply. Reply STOP to opt out or HELP for help. You can adjust your communication preferences once you are a patient.',
  // RETIRED COPY -- last rendered by form version 2026.09.1. Nothing renders it
  // now that the phone field is required; kept so old records still resolve.
  PHONE_OMITTED_NOTICE:
    'If you leave this blank, we will not be able to reach you by phone or text about this appointment.',
  // Deliberately broad: the single textNotif switch this consent will eventually
  // feed covers more than reminders, so a label naming only reminders would grant
  // more than the patient was shown. (Nothing writes that switch yet -- see
  // SMS_OPT_IN_DECLINED_NOTICE -- but the label is the wording a stored record
  // attests to, so it has to be right the first time.)
  SMS_OPT_IN_LABEL:
    'Yes, text me about my care at Derick Dermatology — appointment reminders, confirmations and changes, forms to sign, aftercare instructions and recall reminders. This is optional; you can book without it.',
  // Phrased around the checkbox rather than the number: with the field required
  // again, "by providing your number" would read as consent the patient never
  // gave.
  SMS_DISCLOSURE_V2:
    'If you check the box above, you will receive transactional appointment-related communications from Derick Dermatology. Checking it does not opt you into marketing or promotional texts. Message frequency varies and message and data rates may apply. Reply STOP to opt out or HELP for help. You can adjust your communication preferences once you are a patient.',
  // Scoped to PERMISSION, not to an outcome, and that scoping is the requirement
  // (5.2.14) rather than a stylistic preference.
  //
  // Nothing this release ships changes any patient's preferences: the write that
  // would have made unticking a real opt-out (textNotif = 0 at link time) was
  // DESCOPED after code review. So a notice claiming texts "will stop" would be
  // false twice over -- no consumer writes an opt-out, and CommPrefs::defaultPrefs
  // has textNotif => TRUE, so an established patient with no saved preferences
  // keeps receiving appointment texts either way. Never restore outcome wording
  // unless a consumer actually writes the preference.
  //
  // It also must not coerce (consent has to be voluntary): the consequence is
  // stated once, plainly, with no urgency, and it names the channels that still
  // work and that the choice is changeable once the patient is established, so
  // declining does not read as losing contact with the practice.
  //
  // This string has NEVER SHIPPED -- no stored record resolves to it -- so it was
  // edited in place. The append-only rule (5.2.7) protects wording a patient was
  // actually shown; it does not freeze a draft.
  SMS_OPT_IN_DECLINED_NOTICE:
    'If you leave this box unchecked, we will not have your permission to text you about this appointment. We will still reach you by phone and email, and you can turn text messages on at any time once you are a patient.',
  SMS_TERMS_URL: 'https://derickdermatology.com/sms/',
  PRIVACY_URL: 'https://derickdermatology.com/website-privacy-statement/',
};

/**
 * Stand-in sent when a payload arrives with no phone number.
 *
 * TRANSITIONAL BACKSTOP, not the design: the field is required again as of form
 * version 2026.09.2, but a browser on an older cached bundle can still submit
 * without one, and everything downstream of us requires a phone. Specifically,
 * derick_contact_server's `submitNewContactForm` rejects a blank phone with a
 * DerickException -> HTTP 500, and the internal-services poller only deletes an
 * SQS message on success -- so a blank number would leave the message
 * redelivering indefinitely, creating no contact, meaning no chart is ever
 * provisioned and the appointment is silently never handled. Substituting here
 * keeps that path alive.
 *
 * 847 is a real, local area code, so the value satisfies every validator in the
 * chain (the contact server's regex included). It is a CONVENTION: staff working
 * the contact queue read 847-555-5555 as "the patient did not provide a number".
 * The patient never sees it -- substitution happens at payload assembly only,
 * never in form state.
 *
 * Retiring this is a follow-up, once no old bundles are in circulation.
 *
 * @see docs/REQUIREMENTS.md section 5.2.10
 */
export const UNPROVIDED_PHONE = '8475555555';

/**
 * Practice help line, shown in the footer and on the error/offline/confirmation
 * screens (WCAG 3.2.6 Consistent Help). `tel` is the href form.
 */
export const HELP_PHONE = { display: '(847) 381-8899', tel: '+18473818899' };
